import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirpodRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAirpodRight"><Path d="M16.5 13.083V20.5H19.5V8.5C19.5 5.73858 17.2614 3.5 14.5 3.5C13.3743 3.5 12.3357 3.87223 11.5 4.5V12.499C12.3358 13.127 13.3741 13.5 14.5 13.5C15.2112 13.5 15.8874 13.3507 16.5 13.083ZM16.5 13.083V11" stroke="currentColor"/><Path d="M4.5 17.5V13.5H7C8.10457 13.5 9 14.3954 9 15.5C9 16.6046 8.10457 17.5 7 17.5H4.5ZM4.5 17.5V21" stroke="currentColor"/><Path d="M8.99784 21.0001V20.5001C8.99784 18.879 8.60925 17.502 6.37891 17.502" stroke="currentColor"/></CentralIconBase>;
});

export default IconAirpodRight;
